import { IBriefResource } from "../../briefs";
import { ISkillResource } from "../../skills";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, OneOrManyFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISkillLevelList } from "../types";

export interface ISkillLevelListQueryParameters extends IPaginateable, IOrderable<"level" | "createdAt" | "updatedAt"> {
    filters?: {
        skills?: RelationalFilter<ISkillResource>;
        briefs?: RelationalFilter<IBriefResource>;
        level?: OneOrManyFilter<number>;
    };
}

export type ISkillLevelListQueryResult = ISkillLevelList;

const mapFilters = (filters: ISkillLevelListQueryParameters["filters"]) => {
    const { skills, briefs, level } = filters ?? {};

    return {
        "skill.uuid": mapRelationalFilter(skills),
        "briefs.uuid": mapRelationalFilter(briefs),
        level: level,
    };
};

export const skillLevelListQuery: IApiQueryFunction<ISkillLevelListQueryParameters> = ({
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/skill_levels${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useSkillLevelListQuery = createApiQueryHook<ISkillLevelListQueryParameters, ISkillLevelListQueryResult>(
    skillLevelListQuery,
);
